module.exports = __webpack_public_path__ + "img/home.fe40ff90.svg";